import { createTheme } from '@mui/material/styles';

// Mantis Color Palette
const colors = {
  primary: {
    50: '#e3f2fd', 100: '#bbdefb', 200: '#90caf9', 300: '#64b5f6', 400: '#42a5f5', 500: '#2196f3', 600: '#1e88e5', 700: '#1976d2', 800: '#1565c0', 900: '#0d47a1',
  },
  secondary: {
    50: '#fce4ec', 100: '#f8bbd9', 200: '#f48fb1', 300: '#f06292', 400: '#ec407a', 500: '#e91e63', 600: '#d81b60', 700: '#c2185b', 800: '#ad1457', 900: '#880e4f',
  },
  success: {
    50: '#e8f5e8', 100: '#c8e6c9', 200: '#a5d6a7', 300: '#81c784', 400: '#66bb6a', 500: '#4caf50', 600: '#43a047', 700: '#388e3c', 800: '#2e7d32', 900: '#1b5e20',
  },
  warning: {
    50: '#fff8e1', 100: '#ffecb3', 200: '#ffe082', 300: '#ffd54f', 400: '#ffca28', 500: '#ffc107', 600: '#ffb300', 700: '#ffa000', 800: '#ff8f00', 900: '#ff6f00',
  },
  error: {
    50: '#ffebee', 100: '#ffcdd2', 200: '#ef9a9a', 300: '#e57373', 400: '#ef5350', 500: '#f44336', 600: '#e53935', 700: '#d32f2f', 800: '#c62828', 900: '#b71c1c',
  },
  grey: {
    50: '#fafafa', 100: '#f5f5f5', 200: '#eeeeee', 300: '#e0e0e0', 400: '#bdbdbd', 500: '#9e9e9e', 600: '#757575', 700: '#616161', 800: '#424242', 900: '#212121',
  },
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary[500], light: colors.primary[300], dark: colors.primary[700], contrastText: '#ffffff',
    },
    secondary: {
      main: colors.secondary[500], light: colors.secondary[300], dark: colors.secondary[700], contrastText: '#ffffff',
    },
    success: {
      main: colors.success[500], light: colors.success[300], dark: colors.success[700], contrastText: '#ffffff',
    },
    warning: {
      main: colors.warning[500], light: colors.warning[300], dark: colors.warning[700], contrastText: '#000000',
    },
    error: {
      main: colors.error[500], light: colors.error[300], dark: colors.error[700], contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc', paper: '#ffffff',
    },
    text: {
      primary: colors.grey[800], secondary: colors.grey[600],
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem', fontWeight: 600, lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem', fontWeight: 600, lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem', fontWeight: 600, lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem', lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem', lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', borderRadius: 8, fontWeight: 600, padding: '8px 16px',
        },
        contained: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '1px solid rgba(0,0,0,0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});
